const useGetStoreyTypes = () => 
    // useQuery<string[]>(["storeyTypes"],
    //     async () => await fetchItem<string[]>(ENDPOINTS.STOREY_TYPES) ?? [],
    //     {
    //         staleTime: 60 * 60 * 1000,
    //     })
 ['INFRA', 'SUPER', 'TOIT']

export default useGetStoreyTypes;